<template>
    <div id="comment-section" class="d-flex">
        <div class="text-wrapper d-flex">
            <span>Descreva abaixo tudo o que pensa sobre este produto:</span>
        </div>

        <textarea v-model="comment" @change="updateComment" />
        <span class="rules-btn text-underline" @click="openRules = true">Ver regras</span>
        <Modal v-model="openRules" class="small">
            <div class="rules-modal d-flex">
                <div class="rules-modal-header d-flex">
                    <i class="icon-cr icon-logo-header-cr" />
                    <div class="v-divider" />
                    <span class="logo-text">Painel de Avaliações</span>
                </div>
                <div class="rules-modal-content d-flex">
                    <span class="rules-modal-title text-center">Regras para o comentário:</span>
                    <div class="rules-modal-text">
                        <p>Você não deve:</p>
                        <ul>
                            <li>Fazer comentários ofensivos;</li>
                            <li>Citar o nome de marcas;</li>
                        </ul>
                        <p>
                            Nos nós reservamos no direito de excluir avaliações que descumpram essas
                            regras.
                        </p>
                    </div>
                </div>
                <button class="btn btn-close-modal bg-default-5" @click="openRules = false">
                    Fechar
                </button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Modal from '../../common/container/Modal.vue';

    export default {
        name: 'CommentSection',
        data() {
            return {
                comment: null,
                openRules: false,
            };
        },
        components: { Modal },

        methods: {
            updateComment() {
                this.$emit('update-form', { field: 'review', value: this.comment });
            },
        },
    };
</script>
